// @flow

import type { ButtonSchemeName, Gradient } from '../../../types/theme';

const getGradient = (gradient?: Gradient, colorScheme: ButtonSchemeName) => {
  if (!gradient || !gradient[colorScheme]) {
    return null;
  }
  return gradient[colorScheme];
};

export default getGradient;
